import { MAX_INT_32 } from '../constants';

export const calculateElapsed = (startTime: number, endTime: number) => {
  const formattedStartTime = startTime === 0 ? new Date().getTime() : startTime;
  const time = Math.abs(endTime - formattedStartTime);
  return time > MAX_INT_32 ? -1 : time; // as a safeguard, if the time is greater than the INT32 max, return -1
};
